<template lang="pug">
	.banner-control
		.title {{title}}
		.options-button(v-pseudo-modal-show="this._uid + 'loading-control-dropdown'")
			i.fa.fa-navicon
		div.dropdown-menu.dropdown-menu-right(v-pseudo-modal="this._uid + 'loading-control-dropdown'")
			div.loading-table
				.loading-template.loading-template-0(@click="setLoading(0)")
				.loading-template.loading-template-1(@click="setLoading(1)")
				.loading-template.loading-template-2(@click="setLoading(2)")

</template>

<script>

    import { Creative } from './../../services/Creative';
    import { Settings } from './../../services/Settings';

    export default {
        name: "LoadingTemplatesList",
        props: ['title'],
        data() {

			this.settings = [
				{
					"loading-overlay-show-time": 200,
					"loading-overlay-hide-time": 1000,
					"loading-background-styles": {"background": "radial-gradient(#4ed6fd, #ffffff)", "filter": "blur(5px)", "transform": "scale(1.4)"},
					"loading-icon-styles": {"background": "url($logotype$) no-repeat scroll center center / contain", "left:portrait": "30%", "right:portrait": "30%", "top:portrait": "20%", "bottom:portrait": "35%", "left:landscape": "30%", "right:landscape": "30%", "top:landscape": "25%", "bottom:landscape": "35%"},
					"loading-progress-styles": {"background": "rgba(255, 255, 255, 0.2)", "height": "2px", "padding": "0px", "borderRadius": "0px", "left:portrait": "34%", "right:portrait": "34%", "top:portrait": "60%", "bottom:portrait": "25%", "left:landscape": "40%", "right:landscape": "40%", "top:landscape": "70%", "bottom:landscape": "25%", "filter": "drop-shadow(0px 0px 3px #000000)"},
					"loading-progress-fill-styles": {"background": "rgba(255, 255, 255, 0.8)", "height": "100%", "borderRadius": "0px"},
					"loading-click-out": true,
					"loading-text": "",
					"loading-text-styles": {"color": "#ffffff", "fontFamily": "Arial", "fontWeight": "bold", "fontSize:portrait": "34px", "fontSize:landscape": "34px", "textAlign": "center", "left:portrait": "15%", "right:portrait": "15%", "top:portrait": "40%", "bottom:portrait": "30%", "left:landscape": "35%", "right:landscape": "35%", "top:landscape": "55%", "bottom:landscape": "20%"},
				},
				{
					"loading-overlay-show-time": 200,
					"loading-overlay-hide-time": 1000,
					"loading-background-styles": {"background": "linear-gradient(#5fdafe, #41b2ec)", "filter": "none", "transform": "none"},
					"loading-icon-styles": {"background": "url($logotype$) no-repeat scroll center center / contain", "left:portrait": "30%", "right:portrait": "30%", "top:portrait": "10%", "bottom:portrait": "65%", "left:landscape": "40%", "right:landscape": "40%", "top:landscape": "10%", "bottom:landscape": "50%"},
					"loading-progress-styles": {"background": "rgba(255, 255, 255, 1)", "height": "10px", "padding": "2px", "borderRadius": "10px", "left:portrait": "30%", "right:portrait": "30%", "top:portrait": "60%", "bottom:portrait": "30%", "left:landscape": "40%", "right:landscape": "40%", "top:landscape": "75%", "bottom:landscape": "20%", "filter": "none"},
					"loading-progress-fill-styles": {"background": "#ffbb00", "height": "100%", "borderRadius": "10px"},
					"loading-click-out": true,
					"loading-text": "demo game loading",
					"loading-text-styles": {"color": "#ffffff", "fontFamily": "Arial", "fontWeight": "bold", "fontSize:portrait": "34px", "fontSize:landscape": "34px", "textAlign": "center", "left:portrait": "15%", "right:portrait": "15%", "top:portrait": "40%", "bottom:portrait": "30%", "left:landscape": "35%", "right:landscape": "35%", "top:landscape": "55%", "bottom:landscape": "20%"},
				},
				{
					"loading-overlay-show-time": 200,
					"loading-overlay-hide-time": 1000,
					"loading-background-styles": {"background": "linear-gradient(#5fdafe, #41b2ec)", "filter": "none", "transform": "none"},
					"loading-icon-styles": {"background": "url($logotype$) no-repeat scroll center center / contain", "left:portrait": "30%", "right:portrait": "30%", "top:portrait": "20%", "bottom:portrait": "35%", "left:landscape": "30%", "right:landscape": "30%", "top:landscape": "25%", "bottom:landscape": "35%"},
					"loading-progress-styles": {"background": "rgba(255, 255, 255, 1)", "height": "10px", "padding": "2px", "borderRadius": "10px", "left:portrait": "34%", "right:portrait": "34%", "top:portrait": "60%", "bottom:portrait": "25%", "left:landscape": "40%", "right:landscape": "40%", "top:landscape": "70%", "bottom:landscape": "25%", "filter": "none"},
					"loading-progress-fill-styles": {"background": "#ffbb00", "height": "100%", "borderRadius": "10px"},
					"loading-click-out": false,
					"loading-text": "Play Bonus Game From",
					"loading-text-styles": {"color": "#ffffff", "fontFamily": "Arial", "fontWeight": "bold", "fontSize:portrait": "36px", "fontSize:landscape": "36px", "textAlign": "center", "left:portrait": "15%", "right:portrait": "15%", "top:portrait": "15%", "bottom:portrait": "60%", "left:landscape": "35%", "right:landscape": "35%", "top:landscape": "14%", "bottom:landscape": "50%"},
				}
			];

            return {

            };

        },
        methods: {
            setLoading(id) {

                Broadcast.call("Pseudo Modal Hide", [this._uid + 'loading-control-dropdown']);

                const prefix = this.prefix;

                for (let key in this.settings[id]) {

                    if (!this.settings[id].hasOwnProperty(key)) continue;

                    Settings.setSettingValue(key, this.settings[id][key]);

                }

                Broadcast.call("Update Settings Content", []);

            }
        }
    }
</script>


<style lang="sass">

	.banner-control
		position: relative
		font-size: 0.875rem

	.options-button
		padding: 1rem 0 0 0
		cursor: pointer
		position: absolute
		right: 0px
		top: -20px
		font-size: 0.875rem

	.dropdown-menu
		right: 0px
		top: 20px
		box-shadow: 0 0 10px rgba(0, 0, 0, 0.5)

	.loading-template
		width: 48%
		height: 169px
		background-size: contain
		background-repeat: no-repeat
		background-position: center center
		cursor: pointer
		transition: 0.2s
		margin: 1%
		&:hover
			opacity: 0.8

	.loading-template-0
		background-image: url("./../../assets/loading-template-0.jpg")

	.loading-template-1
		background-image: url("./../../assets/loading-template-1.jpg")

	.loading-template-2
		background-image: url("./../../assets/loading-template-2.jpg")

	/*.loading-template-3*/
	/*	background-image: url("./../../assets/loading-template-3.png")*/

	/*.loading-template-4*/
	/*	background-image: url("./../../assets/loading-template-4.png")*/

	.loading-table
		display: flex
		flex-wrap: wrap

</style>

